import React from 'react';
import { Col, Image } from '@thd-olt-component-react/core-ui';
import classNames from 'classnames/bind';
import { shape, string, bool as boolType } from 'prop-types';
import styles from './RecommendationsProductPodCarousel.module.scss';

const cx = classNames.bind(styles);

const BatteryImage = ({ metadata, scheme, isMobile }) => {

  return (
    <Col xs="4" className={cx('carouselAnchorImage')}>
      <div className="battery-systems__feature--img">
        {metadata?.batteryImageUrl && (
          <Image
            src={metadata?.batteryImageUrl}
            alt="main-product-image"
            height="300"
            width="300"
            data-testid="anchor-image"
          />
        )}
      </div>
      {scheme === 'battery_system' && (
        <div className="battery-systems__feature--title">{metadata?.batteryTitle}</div>
      )}
      <div className="battery-systems__feature--list">
        {/* eslint-disable-next-line react/no-danger */}
        <ul dangerouslySetInnerHTML={{ __html: metadata?.batteryDesc }} />
      </div>
      {metadata?.batteryPlpUrl && (
        <div className="battery-systems__shop--link">
          <a
            href={metadata?.batteryPlpUrl}
            rel="noreferrer"
            target={isMobile ? '_self' : '_blank'}
            data-testid="tooltip-product"
          > Shop {metadata?.batteryName}
          </a>
        </div>
      )}
    </Col>
  );
};

BatteryImage.propTypes = {
  metadata: shape({

  }),
  scheme: string,
  isMobile: boolType
};

BatteryImage.defaultProps = {
  metadata: {},
  scheme: '',
  isMobile: false
};

export default BatteryImage;